import React, {useEffect, useState} from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import {
    Button,
    Card,
    Checkbox,
    Col,
    Form,
    Input,
    Row,
    Space,
    InputNumber
} from "antd";
import ProfileTitle from "../../../../components/ProfileTitle";
import Upload from "../../../../components/Upload";
import AreaSelect from "../../../../components/AreaSelect";
import {useForm} from "antd/lib/form/Form";
import * as api from "../../../../apis/dealer";
import DatePicker from "../../../../components/DatePicker";
import BaseDataSelect from "../../../../components/BaseDataSelect";
import Select from "../../../../components/Select";
import DictSelect from "../../../../components/DictSelect";

function DealerHome() {

    const [form] = useForm()
    const [licenses, setLicenses] = useState<any[]>([])

    useEffect(() => {
        loadData()
    }, [])

    function loadData() {
        api.getDealer(undefined).then(response => {
            form.setFieldsValue(response.data.data)
            setLicenses(response.data.data.licenses)
        })
    }

    return (
        <PageHeaderLayout>
            <Space style={{alignItems: 'stretch', width: '100%'}} direction={"vertical"}>
                <Card title={'基本信息'}>
                    <Form labelCol={{span: 6}} form={form} disabled>
                        <Form.Item name={'id'} noStyle>
                            <Input style={{display: 'none'}}/>
                        </Form.Item>
                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item name={'no'} label={'客户编码'}>
                                    <Input disabled/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name={'name'} label={'客户名称'} rules={[{required: true}]}>
                                    <Input onChange={event => form.setFieldValue('invoiceName', event.target.value)}/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name={'nameShort'} label={'客户简称'}>
                                    <Input/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item name={'dealerGroup'} label={'客户组'} rules={[{required: true}]}>
                                    <BaseDataSelect name={'dealerGroups'} appendNull={false}/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name={'group'} label={'集团'}>
                                    <BaseDataSelect name={'groups'}/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name={'area'} label={'销售地区'} rules={[{required: true}]}>
                                    <BaseDataSelect name={'saleAreas'} appendNull={false}/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item name={'country'} label={'国家'} rules={[{required: true}]}>
                                    <BaseDataSelect name={'countries'} appendNull={false}
                                                    defaultSelectFirst/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name={'currency'} label={'币种'} rules={[{required: true}]}
                                           initialValue={'CNY'}>
                                    <BaseDataSelect name={'currencies'} appendNull={false}/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name={'property'} label={'客户性质'} rules={[{required: true}]}>
                                    <BaseDataSelect name={'dealerNatures'} appendNull={false}/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item name={'zipCode'} label={'客户邮编'}>
                                    <Input/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name={'businessUser'} label={'商务人员'} rules={[{required: true}]}>
                                    <Select url={'/position/dict?type=1'}
                                            getData={(data: any) => data.data.map((i: any) => ({
                                                ...i,
                                                name: `${i.name}(${i.user})`
                                            }))} textField={'name'} valueField={'id'}/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name={'salesUser'} label={'销售人员'} rules={[{required: true}]}>
                                    <Select url={'/position/dict?type=0'}
                                            getData={(data: any) => data.data.map((i: any) => ({
                                                ...i,
                                                name: `${i.name}(${i.user})`
                                            }))} textField={'name'} valueField={'id'}/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item name={'legalRepresentative'} label={'法人代表'}>
                                    <Input/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name={'registeredCapital'} label={'注册资金'}>
                                    <Input/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name={'registeredDate'} label={'成立日期'}>
                                    <DatePicker style={{width: '100%'}} allowClear/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item name={'manager'} label={'总经理姓名'} rules={[{required: true}]}>
                                    <Input/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name={'managerPhone'} label={'总经理电话'} rules={[{required: true}]}>
                                    <Input/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item name={'paymentMethod'} label={'付款方式'} initialValue={'电汇'}>
                                    <DictSelect dict={'PaymentMethod'} appendNull={false}/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name={'salesUser2'} label={'销售人员2'}>
                                    <Select url={'/position/dict?type=0'}
                                            getData={(data: any) => data.data.map((i: any) => ({
                                                ...i,
                                                name: `${i.name}(${i.user})`
                                            }))} textField={'name'} valueField={'id'}/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item name={'creditLimit'} label={'信用额度'}>
                                    <InputNumber min={0} precision={2} addonAfter={'万元'}/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name={'period'} label={'账期'}>
                                    <Select url={'/dict/?typeName=DealerPeriod'}
                                            getData={(data: any) => data.data}
                                            textField={'value'}
                                            valueField={'value'}
                                            suffixIcon={'天'}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={4}>
                                <Form.Item name={'includeTax'} initialValue={true}
                                           valuePropName={"checked"} wrapperCol={{offset: 6}}>
                                    <Checkbox disabled={true}>是否含税</Checkbox>
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item name={'specialBilling'} initialValue={false}
                                           valuePropName={"checked"}
                                           wrapperCol={{offset: 6}}
                                           tooltip={'标记特殊开票，财务开票时进行过滤'}>
                                    <Checkbox>特殊开票</Checkbox>
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item name={'autoWriteOff'} wrapperCol={{offset: 6}} initialValue={false}
                                           valuePropName={"checked"}>
                                    <Checkbox>付款单自动核销</Checkbox>
                                </Form.Item>
                            </Col>
                            <Col span={4}>
                                <Form.Item name={'qualification2'} wrapperCol={{offset: 6}} initialValue={false}
                                           valuePropName={"checked"}>
                                    <Checkbox>2类资质</Checkbox>
                                </Form.Item>
                            </Col>
                            <Col span={4}>
                                <Form.Item name={'qualification3'} initialValue={false} valuePropName={"checked"}>
                                    <Checkbox>3类资质/其他</Checkbox>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    <div>
                        <ProfileTitle>收货地址</ProfileTitle>
                        <Form form={form} disabled>
                            <Row gutter={10} style={{marginBottom: 10}}>
                                <Col span={4} offset={2}>收货人</Col>
                                <Col span={4}>手机</Col>
                                <Col span={3}>省</Col>
                                <Col span={3}>市</Col>
                                <Col span={4}>详细地址</Col>
                                <Col span={4}>默认地址</Col>
                            </Row>
                            <Form.List name={'shipping'} initialValue={[{}]}>
                                {(fields, {add, remove}) => (
                                    fields.map(field => (
                                        <Row gutter={10} key={field.name}>
                                            <Col span={2}>
                                                <Space>
                                                    <Button onClick={() => add()}>+</Button>
                                                    <Button
                                                        onClick={() => fields.length > 1 && remove(field.name)}>-</Button>
                                                </Space>
                                            </Col>
                                            <Col span={4}>
                                                <Form.Item name={[field.name, 'name']}
                                                           rules={[{required: true, message: '请输入收货人'}]}>
                                                    <Input/>
                                                </Form.Item>
                                            </Col>
                                            <Col span={4}>
                                                <Form.Item name={[field.name, 'phone']}
                                                           rules={[{required: true, message: '请输入手机'}]}>
                                                    <Input/>
                                                </Form.Item>
                                            </Col>
                                            <Col span={3}>
                                                <Form.Item name={[field.name, 'provinceId']}
                                                           rules={[{required: true, message: '请选择省份'}]}>
                                                    <AreaSelect/>
                                                </Form.Item>
                                            </Col>
                                            <Col span={3}>
                                                <Form.Item dependencies={[['shipping', field.name, 'provinceId']]}
                                                           noStyle>
                                                    {({getFieldValue}) => {
                                                        const province = getFieldValue(['shipping', field.name, 'provinceId'])
                                                        return (
                                                            <Form.Item name={[field.name, 'cityId']}
                                                                       rules={[{
                                                                           required: true,
                                                                           message: '请选择城市'
                                                                       }]}>
                                                                <AreaSelect type={'city'}
                                                                            parent={province}/>
                                                            </Form.Item>
                                                        )
                                                    }}
                                                </Form.Item>
                                            </Col>
                                            <Col span={4}>
                                                <Form.Item name={[field.name, 'address']}
                                                           rules={[{required: true, message: '请输入详细地址'}]}>
                                                    <Input/>
                                                </Form.Item>
                                            </Col>
                                            <Col span={4}>
                                                <Form.Item name={[field.name, 'default']}
                                                           valuePropName={'checked'}
                                                           initialValue={field.name === 0}>
                                                    <Checkbox onChange={event => {
                                                        const shipping = form.getFieldValue('shipping')
                                                        form.setFieldValue("shipping", shipping.map((i: any, index: number) => ({
                                                            ...i,
                                                            default: field.name === index ? event.target.checked : false
                                                        })))
                                                    }}/>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    ))
                                )}
                            </Form.List>
                        </Form>
                    </div>
                    <br/>
                    <div>
                        <ProfileTitle>开票信息</ProfileTitle>
                        <Form labelCol={{span: 6}} form={form} disabled>
                            <Row gutter={16}>
                                <Col span={8}>
                                    <Form.Item name={'invoiceName'} label={'名称'} rules={[{required: true}]}>
                                        <Input/>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item name={'invoiceType'} label={'发票类型'} rules={[{required: true}]}>
                                        <DictSelect dict={'InvoiceType'} appendNull={false}/>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item name={'taxNo'} label={'税号'} rules={[{required: true}]}>
                                        <Input/>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={8}>
                                    <Form.Item name={'bankName'} label={'开户银行'} rules={[{required: true}]}>
                                        <Input/>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item name={'bankNo'} label={'银行账户'} rules={[{required: true}]}>
                                        <Input/>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item name={'phone'} label={'电话号码'} rules={[{required: true}]}>
                                        <Input/>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={8}>
                                    <Form.Item name={'address'} label={'开票地址'} rules={[{required: true}]}>
                                        <Input/>
                                    </Form.Item>
                                </Col>
                                <Form.Item noStyle dependencies={['invoiceType']}>
                                    {({getFieldValue}) => {
                                        const type = getFieldValue('invoiceType')
                                        const required = type?.endsWith('-E')
                                        return (
                                            <Col span={8}>
                                                <Form.Item name={'invoiceEmail'} label={'电子邮箱'}
                                                           rules={[{required: required}]}>
                                                    <Input/>
                                                </Form.Item>
                                            </Col>
                                        )
                                    }}
                                </Form.Item>
                                <Col span={8}>
                                    <Form.Item name={'salesTaxGroup'} label={'销售税组'}
                                               rules={[{required: true}]} initialValue={'All-专票'}>
                                        <BaseDataSelect name={'salesTaxGroups'} appendNull={false}/>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Form.Item noStyle dependencies={['invoiceType']}>
                                    {({getFieldValue}) => {
                                        const type = getFieldValue('invoiceType')
                                        const required = !type?.endsWith('-E')
                                        return (
                                            <>
                                                <Col span={8}>
                                                    <Form.Item name={'invoiceAddress'} label={'发票邮寄地址'}
                                                               rules={[{required: required}]}>
                                                        <Input/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item name={'invoiceRecipient'} label={'发票邮寄联系人'}
                                                               rules={[{required: required}]}>
                                                        <Input/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item name={'invoicePhone'} label={'发票邮寄联系电话'}
                                                               rules={[{required: required}]}>
                                                        <Input/>
                                                    </Form.Item>
                                                </Col>
                                            </>
                                        )
                                    }}
                                </Form.Item>
                            </Row>
                        </Form>
                    </div>
                    <br/>
                    <div>
                        <ProfileTitle
                            description={'注：附件最大20M，支持格式：PDF、Word、Excel、Txt、JPG、PNG、BMP、GIF、RAR、ZIP'}>
                            资质文件
                        </ProfileTitle>
                        <Form labelCol={{span: 8}} form={form} disabled>
                            <Form.List name={'licenses'}>
                                {(fields) => (
                                    licenses.map((item: any, index: number) => (
                                            <Row key={item.id} gutter={16}>
                                                <Form.Item name={[index, 'licenseId']} initialValue={item.id}>
                                                    <Input style={{display: 'none'}}/>
                                                </Form.Item>
                                                <Col span={12}>
                                                    <Form.Item name={[index, 'path']} label={item.name}
                                                               rules={[{required: item.required}, {validator: Upload.validator({limit: 20 * 1024 * 1024})}]}>
                                                        <Upload maxCount={1}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item label={'有效期'} name={[index, 'expire']}
                                                               rules={[{required: item.requiredExpire}]}>
                                                        <DatePicker.RangePicker/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        )
                                    )
                                )}
                            </Form.List>
                        </Form>
                    </div>
                </Card>
            </Space>
        </PageHeaderLayout>
    )
}

export default DealerHome
